import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'
import { mapOrderItemsForCalculateTotal } from 'utils'

type Items = {
  salePrice: number
  defaultPrice: number
  quantity: number
}

type Params = {
  totalDiscount: number
  totalExpenses: number
  freightPrice: number
  items: Items[]
  isTaxesRecalculePending: boolean
}

export const loadOrderCalculateTotal = (
  params: Params
): Promise<{ total: number }> => {
  return axios.post('/orders/calculate-total', {
    ...params,
    items: mapOrderItemsForCalculateTotal(params.items)
  })
}

export function useLoadOrderCalculateTotal(params: Params) {
  return useQuery(
    ['orderCalculateTotal', params],
    () => loadOrderCalculateTotal(params),
    {
      enabled:
        params?.items?.every((item) => item.defaultPrice >= 0) &&
        params.isTaxesRecalculePending,
      keepPreviousData: true,
      onError: () =>
        toast.error('Não foi possível calcular o total do pedido', {
          toastId: 'orderCalculateTotal'
        })
    }
  )
}
